// extracted by mini-css-extract-plugin
export default {"modalTitle":"modalTitle___WEF7E","modalMessage":"modalMessage___qhxAN","modalButtons":"modalButtons___ce1QX"};